/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { BodyQuizEntryMapRes } from '../_model/bodyQuizEntryMapRes';
import type { CopyQuizsetReq } from '../_model/copyQuizsetReq';
import type { CreateQuizSetReq } from '../_model/createQuizSetReq';
import type { CursorSearchResponseListQuizLibrarySearchItem } from '../_model/cursorSearchResponseListQuizLibrarySearchItem';
import type { CursorSearchResponseListSearchQuizsetRes } from '../_model/cursorSearchResponseListSearchQuizsetRes';
import type { DeleteQuizSetReq } from '../_model/deleteQuizSetReq';
import type { GetQuizSetByEntryMapParams } from '../_model/getQuizSetByEntryMapParams';
import type { GetQuizSetDetailsParams } from '../_model/getQuizSetDetailsParams';
import type { QuizsetCursorSearchReq } from '../_model/quizsetCursorSearchReq';
import type { QuizSetEnterReq } from '../_model/quizSetEnterReq';
import type { QuizsetFilterCriteria } from '../_model/quizsetFilterCriteria';
import type { QuizsetSearchReq } from '../_model/quizsetSearchReq';
import type { QuizsetTitleAutocompleteReq } from '../_model/quizsetTitleAutocompleteReq';
import type { SearchResponseListSearchQuizsetRes } from '../_model/searchResponseListSearchQuizsetRes';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyListQuizsetTitleSuggestionRes } from '../_model/successBodyListQuizsetTitleSuggestionRes';
import type { SuccessBodyQuizAuthorRes } from '../_model/successBodyQuizAuthorRes';
import type { SuccessBodyQuizDetailsRes } from '../_model/successBodyQuizDetailsRes';
import type { SuccessBodyQuizSetBuildInfoRes } from '../_model/successBodyQuizSetBuildInfoRes';
import type { SuccessBodyQuizsetCounts } from '../_model/successBodyQuizsetCounts';
import type { SuccessBodyQuizSetDetailsRes } from '../_model/successBodyQuizSetDetailsRes';
import type { SuccessBodyUploadFileRes } from '../_model/successBodyUploadFileRes';
import type { SuccessBodyUploadImageRes } from '../_model/successBodyUploadImageRes';
import type { UpdateQuizSetReq } from '../_model/updateQuizSetReq';
import type { UploadFileBody } from '../_model/uploadFileBody';
import type { UploadImageBody } from '../_model/uploadImageBody';
import type { VerifyAuthorParams } from '../_model/verifyAuthorParams';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const copyQuizset = (
  sourceQuizsetId: string,
  copyQuizsetReq: BodyType<CopyQuizsetReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetDetailsRes>(
    {
      url: `/quizsets/${sourceQuizsetId}/copy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: copyQuizsetReq,
      signal,
    },
    options,
  );
};

export const getCopyQuizsetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyQuizset>>,
    TError,
    { sourceQuizsetId: string; data: BodyType<CopyQuizsetReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyQuizset>>,
  TError,
  { sourceQuizsetId: string; data: BodyType<CopyQuizsetReq> },
  TContext
> => {
  const mutationKey = ['copyQuizset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyQuizset>>,
    { sourceQuizsetId: string; data: BodyType<CopyQuizsetReq> }
  > = props => {
    const { sourceQuizsetId, data } = props ?? {};

    return copyQuizset(sourceQuizsetId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyQuizsetMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyQuizset>>
>;
export type CopyQuizsetMutationBody = BodyType<CopyQuizsetReq>;
export type CopyQuizsetMutationError = ErrorType<unknown>;

export const useCopyQuizset = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof copyQuizset>>,
      TError,
      { sourceQuizsetId: string; data: BodyType<CopyQuizsetReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof copyQuizset>>,
  TError,
  { sourceQuizsetId: string; data: BodyType<CopyQuizsetReq> },
  TContext
> => {
  const mutationOptions = getCopyQuizsetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const uploadFile = (
  uploadFileBody: BodyType<UploadFileBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUploadFileRes>(
    {
      url: `/quizsets/upload-file`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadFileBody,
      signal,
    },
    options,
  );
};

export const getUploadFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: BodyType<UploadFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyType<UploadFileBody> },
  TContext
> => {
  const mutationKey = ['uploadFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { data: BodyType<UploadFileBody> }
  > = props => {
    const { data } = props ?? {};

    return uploadFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;
export type UploadFileMutationBody = BodyType<UploadFileBody>;
export type UploadFileMutationError = ErrorType<unknown>;

export const useUploadFile = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { data: BodyType<UploadFileBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { data: BodyType<UploadFileBody> },
  TContext
> => {
  const mutationOptions = getUploadFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const autocompleteQuizsetTitles = (
  quizsetTitleAutocompleteReq: BodyType<QuizsetTitleAutocompleteReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListQuizsetTitleSuggestionRes>(
    {
      url: `/quizsets/title-autocomplete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetTitleAutocompleteReq,
      signal,
    },
    options,
  );
};

export const getAutocompleteQuizsetTitlesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof autocompleteQuizsetTitles>>,
    TError,
    { data: BodyType<QuizsetTitleAutocompleteReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof autocompleteQuizsetTitles>>,
  TError,
  { data: BodyType<QuizsetTitleAutocompleteReq> },
  TContext
> => {
  const mutationKey = ['autocompleteQuizsetTitles'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof autocompleteQuizsetTitles>>,
    { data: BodyType<QuizsetTitleAutocompleteReq> }
  > = props => {
    const { data } = props ?? {};

    return autocompleteQuizsetTitles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AutocompleteQuizsetTitlesMutationResult = NonNullable<
  Awaited<ReturnType<typeof autocompleteQuizsetTitles>>
>;
export type AutocompleteQuizsetTitlesMutationBody =
  BodyType<QuizsetTitleAutocompleteReq>;
export type AutocompleteQuizsetTitlesMutationError = ErrorType<unknown>;

export const useAutocompleteQuizsetTitles = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof autocompleteQuizsetTitles>>,
      TError,
      { data: BodyType<QuizsetTitleAutocompleteReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof autocompleteQuizsetTitles>>,
  TError,
  { data: BodyType<QuizsetTitleAutocompleteReq> },
  TContext
> => {
  const mutationOptions = getAutocompleteQuizsetTitlesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const countQuizsetsBySubject = (
  quizsetFilterCriteria: BodyType<QuizsetFilterCriteria>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetCounts>(
    {
      url: `/quizsets/subject-counts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFilterCriteria,
      signal,
    },
    options,
  );
};

export const getCountQuizsetsBySubjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof countQuizsetsBySubject>>,
    TError,
    { data: BodyType<QuizsetFilterCriteria> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof countQuizsetsBySubject>>,
  TError,
  { data: BodyType<QuizsetFilterCriteria> },
  TContext
> => {
  const mutationKey = ['countQuizsetsBySubject'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof countQuizsetsBySubject>>,
    { data: BodyType<QuizsetFilterCriteria> }
  > = props => {
    const { data } = props ?? {};

    return countQuizsetsBySubject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CountQuizsetsBySubjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof countQuizsetsBySubject>>
>;
export type CountQuizsetsBySubjectMutationBody =
  BodyType<QuizsetFilterCriteria>;
export type CountQuizsetsBySubjectMutationError = ErrorType<unknown>;

export const useCountQuizsetsBySubject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof countQuizsetsBySubject>>,
      TError,
      { data: BodyType<QuizsetFilterCriteria> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof countQuizsetsBySubject>>,
  TError,
  { data: BodyType<QuizsetFilterCriteria> },
  TContext
> => {
  const mutationOptions = getCountQuizsetsBySubjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 공개 퀴즈셋 목록/검색은 cursor 기반 POST /quizsets/search/cursor 를 사용하세요.
 * @deprecated
 * @summary 퀴즈셋 검색 (Deprecated)
 */
export const searchQuizsets = (
  quizsetSearchReq: BodyType<QuizsetSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SearchResponseListSearchQuizsetRes>(
    {
      url: `/quizsets/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchQuizsetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchQuizsets>>,
    TError,
    { data: BodyType<QuizsetSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchQuizsets>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationKey = ['searchQuizsets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchQuizsets>>,
    { data: BodyType<QuizsetSearchReq> }
  > = props => {
    const { data } = props ?? {};

    return searchQuizsets(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchQuizsetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchQuizsets>>
>;
export type SearchQuizsetsMutationBody = BodyType<QuizsetSearchReq>;
export type SearchQuizsetsMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary 퀴즈셋 검색 (Deprecated)
 */
export const useSearchQuizsets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchQuizsets>>,
      TError,
      { data: BodyType<QuizsetSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchQuizsets>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchQuizsetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchQuizsetsByCursor = (
  quizsetCursorSearchReq: BodyType<QuizsetCursorSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<CursorSearchResponseListSearchQuizsetRes>(
    {
      url: `/quizsets/search/cursor`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetCursorSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchQuizsetsByCursorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchQuizsetsByCursor>>,
    TError,
    { data: BodyType<QuizsetCursorSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchQuizsetsByCursor>>,
  TError,
  { data: BodyType<QuizsetCursorSearchReq> },
  TContext
> => {
  const mutationKey = ['searchQuizsetsByCursor'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchQuizsetsByCursor>>,
    { data: BodyType<QuizsetCursorSearchReq> }
  > = props => {
    const { data } = props ?? {};

    return searchQuizsetsByCursor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchQuizsetsByCursorMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchQuizsetsByCursor>>
>;
export type SearchQuizsetsByCursorMutationBody =
  BodyType<QuizsetCursorSearchReq>;
export type SearchQuizsetsByCursorMutationError = ErrorType<unknown>;

export const useSearchQuizsetsByCursor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchQuizsetsByCursor>>,
      TError,
      { data: BodyType<QuizsetCursorSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchQuizsetsByCursor>>,
  TError,
  { data: BodyType<QuizsetCursorSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchQuizsetsByCursorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 게스트(비로그인) 허용. 게스트는 IP 당 분당 요청 수 제한, 초과 시 429 TOO_MANY_IMAGE_UPLOAD_REQUESTS.
 * @summary 퀴즈 이미지 업로드
 */
export const uploadImage = (
  uploadImageBody: BodyType<UploadImageBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUploadImageRes>(
    {
      url: `/quizsets/image`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadImageBody,
      signal,
    },
    options,
  );
};

export const getUploadImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadImage>>,
    TError,
    { data: BodyType<UploadImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadImage>>,
  TError,
  { data: BodyType<UploadImageBody> },
  TContext
> => {
  const mutationKey = ['uploadImage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadImage>>,
    { data: BodyType<UploadImageBody> }
  > = props => {
    const { data } = props ?? {};

    return uploadImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadImage>>
>;
export type UploadImageMutationBody = BodyType<UploadImageBody>;
export type UploadImageMutationError = ErrorType<unknown>;

/**
 * @summary 퀴즈 이미지 업로드
 */
export const useUploadImage = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadImage>>,
      TError,
      { data: BodyType<UploadImageBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadImage>>,
  TError,
  { data: BodyType<UploadImageBody> },
  TContext
> => {
  const mutationOptions = getUploadImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getQuizSetByEnterCode = (
  quizSetEnterReq: BodyType<QuizSetEnterReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizDetailsRes>(
    {
      url: `/quizsets/enter-code`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizSetEnterReq,
      signal,
    },
    options,
  );
};

export const getGetQuizSetByEnterCodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getQuizSetByEnterCode>>,
    TError,
    { data: BodyType<QuizSetEnterReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getQuizSetByEnterCode>>,
  TError,
  { data: BodyType<QuizSetEnterReq> },
  TContext
> => {
  const mutationKey = ['getQuizSetByEnterCode'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getQuizSetByEnterCode>>,
    { data: BodyType<QuizSetEnterReq> }
  > = props => {
    const { data } = props ?? {};

    return getQuizSetByEnterCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetQuizSetByEnterCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetByEnterCode>>
>;
export type GetQuizSetByEnterCodeMutationBody = BodyType<QuizSetEnterReq>;
export type GetQuizSetByEnterCodeMutationError = ErrorType<unknown>;

export const useGetQuizSetByEnterCode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getQuizSetByEnterCode>>,
      TError,
      { data: BodyType<QuizSetEnterReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getQuizSetByEnterCode>>,
  TError,
  { data: BodyType<QuizSetEnterReq> },
  TContext
> => {
  const mutationOptions = getGetQuizSetByEnterCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const createQuizSet = (
  createQuizSetReq: BodyType<CreateQuizSetReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetDetailsRes>(
    {
      url: `/quizsets/create`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuizSetReq,
      signal,
    },
    options,
  );
};

export const getCreateQuizSetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuizSet>>,
    TError,
    { data: BodyType<CreateQuizSetReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuizSet>>,
  TError,
  { data: BodyType<CreateQuizSetReq> },
  TContext
> => {
  const mutationKey = ['createQuizSet'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuizSet>>,
    { data: BodyType<CreateQuizSetReq> }
  > = props => {
    const { data } = props ?? {};

    return createQuizSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuizSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuizSet>>
>;
export type CreateQuizSetMutationBody = BodyType<CreateQuizSetReq>;
export type CreateQuizSetMutationError = ErrorType<unknown>;

export const useCreateQuizSet = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createQuizSet>>,
      TError,
      { data: BodyType<CreateQuizSetReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createQuizSet>>,
  TError,
  { data: BodyType<CreateQuizSetReq> },
  TContext
> => {
  const mutationOptions = getCreateQuizSetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchQuizLibrary = (
  quizsetCursorSearchReq: BodyType<QuizsetCursorSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<CursorSearchResponseListQuizLibrarySearchItem>(
    {
      url: `/quiz-library/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetCursorSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchQuizLibraryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchQuizLibrary>>,
    TError,
    { data: BodyType<QuizsetCursorSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchQuizLibrary>>,
  TError,
  { data: BodyType<QuizsetCursorSearchReq> },
  TContext
> => {
  const mutationKey = ['searchQuizLibrary'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchQuizLibrary>>,
    { data: BodyType<QuizsetCursorSearchReq> }
  > = props => {
    const { data } = props ?? {};

    return searchQuizLibrary(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchQuizLibraryMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchQuizLibrary>>
>;
export type SearchQuizLibraryMutationBody = BodyType<QuizsetCursorSearchReq>;
export type SearchQuizLibraryMutationError = ErrorType<unknown>;

export const useSearchQuizLibrary = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchQuizLibrary>>,
      TError,
      { data: BodyType<QuizsetCursorSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchQuizLibrary>>,
  TError,
  { data: BodyType<QuizsetCursorSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchQuizLibraryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const resetQuizSetPlayerHistories = (
  id: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/quizsets/${id}/reset`, method: 'PATCH' },
    options,
  );
};

export const getResetQuizSetPlayerHistoriesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['resetQuizSetPlayerHistories'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return resetQuizSetPlayerHistories(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetQuizSetPlayerHistoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>
>;

export type ResetQuizSetPlayerHistoriesMutationError = ErrorType<unknown>;

export const useResetQuizSetPlayerHistories = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetQuizSetPlayerHistories>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getResetQuizSetPlayerHistoriesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const editQuizSet = (
  updateQuizSetReq: BodyType<UpdateQuizSetReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyQuizSetDetailsRes>(
    {
      url: `/quizsets/edit`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizSetReq,
    },
    options,
  );
};

export const getEditQuizSetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editQuizSet>>,
    TError,
    { data: BodyType<UpdateQuizSetReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editQuizSet>>,
  TError,
  { data: BodyType<UpdateQuizSetReq> },
  TContext
> => {
  const mutationKey = ['editQuizSet'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editQuizSet>>,
    { data: BodyType<UpdateQuizSetReq> }
  > = props => {
    const { data } = props ?? {};

    return editQuizSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditQuizSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof editQuizSet>>
>;
export type EditQuizSetMutationBody = BodyType<UpdateQuizSetReq>;
export type EditQuizSetMutationError = ErrorType<unknown>;

export const useEditQuizSet = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editQuizSet>>,
      TError,
      { data: BodyType<UpdateQuizSetReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editQuizSet>>,
  TError,
  { data: BodyType<UpdateQuizSetReq> },
  TContext
> => {
  const mutationOptions = getEditQuizSetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteQuizSet = (
  deleteQuizSetReq: BodyType<DeleteQuizSetReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/quizsets/delete`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: deleteQuizSetReq,
    },
    options,
  );
};

export const getDeleteQuizSetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuizSet>>,
    TError,
    { data: BodyType<DeleteQuizSetReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteQuizSet>>,
  TError,
  { data: BodyType<DeleteQuizSetReq> },
  TContext
> => {
  const mutationKey = ['deleteQuizSet'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteQuizSet>>,
    { data: BodyType<DeleteQuizSetReq> }
  > = props => {
    const { data } = props ?? {};

    return deleteQuizSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteQuizSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteQuizSet>>
>;
export type DeleteQuizSetMutationBody = BodyType<DeleteQuizSetReq>;
export type DeleteQuizSetMutationError = ErrorType<unknown>;

export const useDeleteQuizSet = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteQuizSet>>,
      TError,
      { data: BodyType<DeleteQuizSetReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteQuizSet>>,
  TError,
  { data: BodyType<DeleteQuizSetReq> },
  TContext
> => {
  const mutationOptions = getDeleteQuizSetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 엔트리맵 해시 ID를 통해 퀴즈셋을 조회합니다. AI 번역이 활성화된 경우 지정된 언어로 번역된 퀴즈를 제공합니다.
 * @summary 퀴즈셋 조회 (엔트리맵 해시 ID 기반)
 */
export const getQuizSetByEntryMap = (
  params: GetQuizSetByEntryMapParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<BodyQuizEntryMapRes | SuccessBody>(
    { url: `/quizsets/entry-map`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizSetByEntryMapQueryKey = (
  params: GetQuizSetByEntryMapParams,
) => {
  return [`/quizsets/entry-map`, ...(params ? [params] : [])] as const;
};

export const getGetQuizSetByEntryMapQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetByEntryMapQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetByEntryMap>>
  > = ({ signal }) => getQuizSetByEntryMap(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetByEntryMapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetByEntryMap>>
>;
export type GetQuizSetByEntryMapQueryError = ErrorType<BodyQuizEntryMapRes>;

export function useGetQuizSetByEntryMap<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetByEntryMap>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetByEntryMap<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetByEntryMap>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetByEntryMap<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 퀴즈셋 조회 (엔트리맵 해시 ID 기반)
 */

export function useGetQuizSetByEntryMap<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetByEntryMapQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetByEntryMapSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetByEntryMapQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetByEntryMap>>
  > = ({ signal }) => getQuizSetByEntryMap(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetByEntryMapSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetByEntryMap>>
>;
export type GetQuizSetByEntryMapSuspenseQueryError =
  ErrorType<BodyQuizEntryMapRes>;

export function useGetQuizSetByEntryMapSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetByEntryMapSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetByEntryMapSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 퀴즈셋 조회 (엔트리맵 해시 ID 기반)
 */

export function useGetQuizSetByEntryMapSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
  TError = ErrorType<BodyQuizEntryMapRes>,
>(
  params: GetQuizSetByEntryMapParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetByEntryMap>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizSetByEntryMapSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizSetDetails = (
  params: GetQuizSetDetailsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetDetailsRes>(
    { url: `/quizsets/details`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizSetDetailsQueryKey = (
  params: GetQuizSetDetailsParams,
) => {
  return [`/quizsets/details`, ...(params ? [params] : [])] as const;
};

export const getGetQuizSetDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetDetails>>
  > = ({ signal }) => getQuizSetDetails(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetDetails>>
>;
export type GetQuizSetDetailsQueryError = ErrorType<unknown>;

export function useGetQuizSetDetails<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetDetails>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetDetails<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetDetails>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetDetails<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizSetDetails<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetDetails>>
  > = ({ signal }) => getQuizSetDetails(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetDetailsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetDetails>>
>;
export type GetQuizSetDetailsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizSetDetailsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetDetailsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetDetailsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizSetDetailsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetDetails>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetDetailsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizSetDetailsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizSetBuildInfo = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetBuildInfoRes>(
    { url: `/quizsets/build-info`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizSetBuildInfoQueryKey = () => {
  return [`/quizsets/build-info`] as const;
};

export const getGetQuizSetBuildInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetBuildInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetBuildInfo>>
  > = ({ signal }) => getQuizSetBuildInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetBuildInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetBuildInfo>>
>;
export type GetQuizSetBuildInfoQueryError =
  ErrorType<SuccessBodyQuizSetBuildInfoRes>;

export function useGetQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetBuildInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetBuildInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetBuildInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetBuildInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetBuildInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetBuildInfo>>
  > = ({ signal }) => getQuizSetBuildInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetBuildInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetBuildInfo>>
>;
export type GetQuizSetBuildInfoSuspenseQueryError =
  ErrorType<SuccessBodyQuizSetBuildInfoRes>;

export function useGetQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
  TError = ErrorType<SuccessBodyQuizSetBuildInfoRes>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizSetBuildInfoSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGuestQuizSetBuildInfo = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetBuildInfoRes>(
    { url: `/quizsets/build-info/guest`, method: 'GET', signal },
    options,
  );
};

export const getGetGuestQuizSetBuildInfoQueryKey = () => {
  return [`/quizsets/build-info/guest`] as const;
};

export const getGetGuestQuizSetBuildInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGuestQuizSetBuildInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
  > = ({ signal }) => getGuestQuizSetBuildInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGuestQuizSetBuildInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
>;
export type GetGuestQuizSetBuildInfoQueryError = ErrorType<unknown>;

export function useGetGuestQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGuestQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
          TError,
          Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGuestQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetGuestQuizSetBuildInfo<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGuestQuizSetBuildInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetGuestQuizSetBuildInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGuestQuizSetBuildInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
  > = ({ signal }) => getGuestQuizSetBuildInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGuestQuizSetBuildInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>
>;
export type GetGuestQuizSetBuildInfoSuspenseQueryError = ErrorType<unknown>;

export function useGetGuestQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGuestQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGuestQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetGuestQuizSetBuildInfoSuspense<
  TData = Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getGuestQuizSetBuildInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetGuestQuizSetBuildInfoSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const verifyAuthor = (
  params: VerifyAuthorParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizAuthorRes>(
    { url: `/quizsets/author`, method: 'GET', params, signal },
    options,
  );
};

export const getVerifyAuthorQueryKey = (params: VerifyAuthorParams) => {
  return [`/quizsets/author`, ...(params ? [params] : [])] as const;
};

export const getVerifyAuthorQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAuthor>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyAuthorQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyAuthor>>> = ({
    signal,
  }) => verifyAuthor(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyAuthor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type VerifyAuthorQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyAuthor>>
>;
export type VerifyAuthorQueryError = ErrorType<unknown>;

export function useVerifyAuthor<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAuthor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyAuthor>>,
          TError,
          Awaited<ReturnType<typeof verifyAuthor>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useVerifyAuthor<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAuthor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifyAuthor>>,
          TError,
          Awaited<ReturnType<typeof verifyAuthor>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useVerifyAuthor<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAuthor>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useVerifyAuthor<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof verifyAuthor>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getVerifyAuthorQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getVerifyAuthorSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof verifyAuthor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyAuthorQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyAuthor>>> = ({
    signal,
  }) => verifyAuthor(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof verifyAuthor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type VerifyAuthorSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyAuthor>>
>;
export type VerifyAuthorSuspenseQueryError = ErrorType<unknown>;

export function useVerifyAuthorSuspense<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof verifyAuthor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useVerifyAuthorSuspense<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof verifyAuthor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useVerifyAuthorSuspense<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof verifyAuthor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useVerifyAuthorSuspense<
  TData = Awaited<ReturnType<typeof verifyAuthor>>,
  TError = ErrorType<unknown>,
>(
  params: VerifyAuthorParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof verifyAuthor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getVerifyAuthorSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
